__turbopack_context__.v({
  "buttonPrimary___69VqU": "PlasmicHomepage-module__sSu2CG__buttonPrimary___69VqU",
  "buttonPrimary__d6JGk": "PlasmicHomepage-module__sSu2CG__buttonPrimary__d6JGk",
  "buttonPrimary__iMBt": "PlasmicHomepage-module__sSu2CG__buttonPrimary__iMBt",
  "buttonPrimary__o9DsS": "PlasmicHomepage-module__sSu2CG__buttonPrimary__o9DsS",
  "card___1FGk4": "PlasmicHomepage-module__sSu2CG__card___1FGk4",
  "card___6NUtr": "PlasmicHomepage-module__sSu2CG__card___6NUtr",
  "card__aDtb7": "PlasmicHomepage-module__sSu2CG__card__aDtb7",
  "card__aXph": "PlasmicHomepage-module__sSu2CG__card__aXph",
  "card__cktJv": "PlasmicHomepage-module__sSu2CG__card__cktJv",
  "card__wtk19": "PlasmicHomepage-module__sSu2CG__card__wtk19",
  "carouselBtn__o7FdC": "PlasmicHomepage-module__sSu2CG__carouselBtn__o7FdC",
  "carouselBtn__oOqYf": "PlasmicHomepage-module__sSu2CG__carouselBtn__oOqYf",
  "column___0Fooe": "PlasmicHomepage-module__sSu2CG__column___0Fooe",
  "column___65Icd": "PlasmicHomepage-module__sSu2CG__column___65Icd",
  "column__g7L31": "PlasmicHomepage-module__sSu2CG__column__g7L31",
  "column__mQtMc": "PlasmicHomepage-module__sSu2CG__column__mQtMc",
  "column__p3MwJ": "PlasmicHomepage-module__sSu2CG__column__p3MwJ",
  "column__tJ8Fl": "PlasmicHomepage-module__sSu2CG__column__tJ8Fl",
  "column__w2MkW": "PlasmicHomepage-module__sSu2CG__column__w2MkW",
  "column__zlcq0": "PlasmicHomepage-module__sSu2CG__column__zlcq0",
  "columns__b4Z7V": "PlasmicHomepage-module__sSu2CG__columns__b4Z7V",
  "columns__enOqw": "PlasmicHomepage-module__sSu2CG__columns__enOqw",
  "crossSvg": "PlasmicHomepage-module__sSu2CG__crossSvg",
  "faq": "PlasmicHomepage-module__sSu2CG__faq",
  "faqItem___73PT": "PlasmicHomepage-module__sSu2CG__faqItem___73PT",
  "faqItem__eNui": "PlasmicHomepage-module__sSu2CG__faqItem__eNui",
  "faqItem__mzlT8": "PlasmicHomepage-module__sSu2CG__faqItem__mzlT8",
  "faqItem__uh57B": "PlasmicHomepage-module__sSu2CG__faqItem__uh57B",
  "faqItem__ybDVa": "PlasmicHomepage-module__sSu2CG__faqItem__ybDVa",
  "faqItem__zSqbo": "PlasmicHomepage-module__sSu2CG__faqItem__zSqbo",
  "footerSection": "PlasmicHomepage-module__sSu2CG__footerSection",
  "freeBox___0Bhpt": "PlasmicHomepage-module__sSu2CG__freeBox___0Bhpt",
  "freeBox___29D9L": "PlasmicHomepage-module__sSu2CG__freeBox___29D9L",
  "freeBox___9D6L3": "PlasmicHomepage-module__sSu2CG__freeBox___9D6L3",
  "freeBox___9M2Ge": "PlasmicHomepage-module__sSu2CG__freeBox___9M2Ge",
  "freeBox__gtL2Q": "PlasmicHomepage-module__sSu2CG__freeBox__gtL2Q",
  "freeBox__hdyp0": "PlasmicHomepage-module__sSu2CG__freeBox__hdyp0",
  "freeBox__jDp4M": "PlasmicHomepage-module__sSu2CG__freeBox__jDp4M",
  "freeBox__joVAb": "PlasmicHomepage-module__sSu2CG__freeBox__joVAb",
  "freeBox__kjnLc": "PlasmicHomepage-module__sSu2CG__freeBox__kjnLc",
  "freeBox__knyOw": "PlasmicHomepage-module__sSu2CG__freeBox__knyOw",
  "freeBox__kr0Wn": "PlasmicHomepage-module__sSu2CG__freeBox__kr0Wn",
  "freeBox__kwbI6": "PlasmicHomepage-module__sSu2CG__freeBox__kwbI6",
  "freeBox__l0Jo": "PlasmicHomepage-module__sSu2CG__freeBox__l0Jo",
  "freeBox__pd2J1": "PlasmicHomepage-module__sSu2CG__freeBox__pd2J1",
  "freeBox__q1Fqe": "PlasmicHomepage-module__sSu2CG__freeBox__q1Fqe",
  "freeBox__r7Sdi": "PlasmicHomepage-module__sSu2CG__freeBox__r7Sdi",
  "freeBox__rEfCt": "PlasmicHomepage-module__sSu2CG__freeBox__rEfCt",
  "freeBox__rHqQm": "PlasmicHomepage-module__sSu2CG__freeBox__rHqQm",
  "freeBox__sP81P": "PlasmicHomepage-module__sSu2CG__freeBox__sP81P",
  "freeBox__tOmlP": "PlasmicHomepage-module__sSu2CG__freeBox__tOmlP",
  "freeBox__u1Tm4": "PlasmicHomepage-module__sSu2CG__freeBox__u1Tm4",
  "freeBox__u5XlR": "PlasmicHomepage-module__sSu2CG__freeBox__u5XlR",
  "freeBox__uOxWo": "PlasmicHomepage-module__sSu2CG__freeBox__uOxWo",
  "freeBox__uliO": "PlasmicHomepage-module__sSu2CG__freeBox__uliO",
  "freeBox__xoc9L": "PlasmicHomepage-module__sSu2CG__freeBox__xoc9L",
  "freeBox__yQzPe": "PlasmicHomepage-module__sSu2CG__freeBox__yQzPe",
  "h1___5W7Dd": "PlasmicHomepage-module__sSu2CG__h1___5W7Dd",
  "h1__aCtaQ": "PlasmicHomepage-module__sSu2CG__h1__aCtaQ",
  "h1__q4YVb": "PlasmicHomepage-module__sSu2CG__h1__q4YVb",
  "h2__j1V5": "PlasmicHomepage-module__sSu2CG__h2__j1V5",
  "h2__mcFu8": "PlasmicHomepage-module__sSu2CG__h2__mcFu8",
  "h2__vR6O": "PlasmicHomepage-module__sSu2CG__h2__vR6O",
  "h3": "PlasmicHomepage-module__sSu2CG__h3",
  "h4": "PlasmicHomepage-module__sSu2CG__h4",
  "headerHeroSection": "PlasmicHomepage-module__sSu2CG__headerHeroSection",
  "homePageWrapper": "PlasmicHomepage-module__sSu2CG__homePageWrapper",
  "img__aqvZ": "PlasmicHomepage-module__sSu2CG__img__aqvZ",
  "img__g3Y5B": "PlasmicHomepage-module__sSu2CG__img__g3Y5B",
  "img__ivAoc": "PlasmicHomepage-module__sSu2CG__img__ivAoc",
  "img__uOJc": "PlasmicHomepage-module__sSu2CG__img__uOJc",
  "lgPresetMessage": "PlasmicHomepage-module__sSu2CG__lgPresetMessage",
  "lgctaButton___0SKe0": "PlasmicHomepage-module__sSu2CG__lgctaButton___0SKe0",
  "lgctaButton___262En": "PlasmicHomepage-module__sSu2CG__lgctaButton___262En",
  "lgctaButton__kGkY": "PlasmicHomepage-module__sSu2CG__lgctaButton__kGkY",
  "lgctaButton__nUsF": "PlasmicHomepage-module__sSu2CG__lgctaButton__nUsF",
  "link___0Xupe": "PlasmicHomepage-module__sSu2CG__link___0Xupe",
  "link___9PgcJ": "PlasmicHomepage-module__sSu2CG__link___9PgcJ",
  "link__j06GV": "PlasmicHomepage-module__sSu2CG__link__j06GV",
  "link__n50Rb": "PlasmicHomepage-module__sSu2CG__link__n50Rb",
  "link__og3Dt": "PlasmicHomepage-module__sSu2CG__link__og3Dt",
  "link__wqIu6": "PlasmicHomepage-module__sSu2CG__link__wqIu6",
  "menuButton": "PlasmicHomepage-module__sSu2CG__menuButton",
  "menuCloseButton": "PlasmicHomepage-module__sSu2CG__menuCloseButton",
  "mobileMenu": "PlasmicHomepage-module__sSu2CG__mobileMenu",
  "pageWrapper": "PlasmicHomepage-module__sSu2CG__pageWrapper",
  "procRerum": "PlasmicHomepage-module__sSu2CG__procRerum",
  "reviewCard___4ZzZn": "PlasmicHomepage-module__sSu2CG__reviewCard___4ZzZn",
  "reviewCard___5VXx": "PlasmicHomepage-module__sSu2CG__reviewCard___5VXx",
  "reviewCard__lQxvG": "PlasmicHomepage-module__sSu2CG__reviewCard__lQxvG",
  "reviewCard__muj0": "PlasmicHomepage-module__sSu2CG__reviewCard__muj0",
  "reviewCard__rovW": "PlasmicHomepage-module__sSu2CG__reviewCard__rovW",
  "reviewCard__ugik3": "PlasmicHomepage-module__sSu2CG__reviewCard__ugik3",
  "reviewsSection": "PlasmicHomepage-module__sSu2CG__reviewsSection",
  "section__eOdD1": "PlasmicHomepage-module__sSu2CG__section__eOdD1",
  "section__j6CNl": "PlasmicHomepage-module__sSu2CG__section__j6CNl",
  "slider": "PlasmicHomepage-module__sSu2CG__slider",
  "slider2": "PlasmicHomepage-module__sSu2CG__slider2",
  "sliderCarousel": "PlasmicHomepage-module__sSu2CG__sliderCarousel",
  "sliderThumb__iR2Rs": "PlasmicHomepage-module__sSu2CG__sliderThumb__iR2Rs",
  "sliderThumb__kCqqm": "PlasmicHomepage-module__sSu2CG__sliderThumb__kCqqm",
  "svg___064Vr": "PlasmicHomepage-module__sSu2CG__svg___064Vr",
  "svg___2KqB2": "PlasmicHomepage-module__sSu2CG__svg___2KqB2",
  "svg___3E544": "PlasmicHomepage-module__sSu2CG__svg___3E544",
  "svg___95UhQ": "PlasmicHomepage-module__sSu2CG__svg___95UhQ",
  "svg__f1OzT": "PlasmicHomepage-module__sSu2CG__svg__f1OzT",
  "svg__g5LGx": "PlasmicHomepage-module__sSu2CG__svg__g5LGx",
  "svg__ie83C": "PlasmicHomepage-module__sSu2CG__svg__ie83C",
  "svg__is6Jr": "PlasmicHomepage-module__sSu2CG__svg__is6Jr",
  "svg__wHh33": "PlasmicHomepage-module__sSu2CG__svg__wHh33",
  "svg__xsmga": "PlasmicHomepage-module__sSu2CG__svg__xsmga",
  "text___0MXX": "PlasmicHomepage-module__sSu2CG__text___0MXX",
  "text___69WUj": "PlasmicHomepage-module__sSu2CG__text___69WUj",
  "text__ap2J": "PlasmicHomepage-module__sSu2CG__text__ap2J",
  "text__dcO90": "PlasmicHomepage-module__sSu2CG__text__dcO90",
  "text__ddqE": "PlasmicHomepage-module__sSu2CG__text__ddqE",
  "text__k5MQr": "PlasmicHomepage-module__sSu2CG__text__k5MQr",
  "text__nyAaZ": "PlasmicHomepage-module__sSu2CG__text__nyAaZ",
  "text__pocTp": "PlasmicHomepage-module__sSu2CG__text__pocTp",
  "text__v7GAp": "PlasmicHomepage-module__sSu2CG__text__v7GAp",
  "text__xrfUg": "PlasmicHomepage-module__sSu2CG__text__xrfUg",
  "whyRerum": "PlasmicHomepage-module__sSu2CG__whyRerum",
  "whyRerum__bfiei": "PlasmicHomepage-module__sSu2CG__whyRerum__bfiei",
  "whyRerum__dneXi": "PlasmicHomepage-module__sSu2CG__whyRerum__dneXi",
  "whyRerum__i99YP": "PlasmicHomepage-module__sSu2CG__whyRerum__i99YP",
});
